import { render } from "./OMSBlock.vue?vue&type=template&id=04da0f43&scoped=true"
import script from "./OMSBlock.vue?vue&type=script&lang=js"
export * from "./OMSBlock.vue?vue&type=script&lang=js"

import "./OMSBlock.vue?vue&type=style&index=0&id=04da0f43&scoped=true&lang=css"

import exportComponent from "C:\\Users\\admin\\Desktop\\Расчосков\\rascheskov_katarakta_lending\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04da0f43"]])

export default __exports__